const pino = require('pino')
const _ = require('lodash')
const {PHASE_PRODUCTION_BUILD} = require('next/constants')

const isDevelopment = process.env.NODE_ENV !== 'production'
const isProduction = process.env.NODE_ENV === 'production'
const isTesting =
  process.env.INSTANCE_PURPOSE === 'testing' || process.env.instancePurpose === 'testing'
const isBuild = process.env.NEXT_PHASE === PHASE_PRODUCTION_BUILD

const send = _.throttle((level, event) => {
  fetch('/api/log-9a67b7c2-d7b9-4437-8544-c3be3965794d', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(event),
  }).catch(() => {
    // Offline or aborted; nowhere left to report it
  })
}, 100)

module.exports = {
  isDevelopment,
  isProduction,
  isTesting,
  isBuild,
  logger: pino({
    browser: {
      transmit: {
        level: 'info',
        send: send,
      },
    },
    base: undefined,
    level: isDevelopment ? 'debug' : 'info',
    //PZ: browser worker intreferring with app router
    // transport: isDevelopment
    //   ? {
    //       target: 'pino-pretty',
    //       options: {
    //         colorize: true,
    //         translateTime: true,
    //       },
    //     }
    //   : undefined,
    // Add requestId to every log line when running in Node (Lambda)
    mixin() {
      if (isDevelopment) return {}

      try {
        // eslint-disable-next-line
        console.log('common.js mixin: start')
        // Only on Node (not browser/edge)
        const isNode =
          typeof process !== 'undefined' && !!(process.versions && process.versions.node)
        // eslint-disable-next-line
        console.log('common.js mixin: isNode', isNode)

        if (!isNode) return {}

        // Prevent bundlers from statically analyzing the require
        const req =
          typeof __non_webpack_require__ === 'function' ? __non_webpack_require__ : eval('require')

        // eslint-disable-next-line
        console.log('common.js mixin: after req')

        // Resolve at call time to hit the active ALS instance
        const {getCorrelationId} = req('./utils/log-context')

        // eslint-disable-next-line
        console.log('common.js mixin: getCorrelationId', getCorrelationId)

        const requestId = getCorrelationId && getCorrelationId()

        // eslint-disable-next-line
        console.log('common.js mixin: requestId', requestId)

        return requestId ? {requestId} : {}
      } catch (_) {
        return {}
      }
    },
  }),
}
